/**
 *
 * @page 用户中心/我的消息/管家中心
 *
 **/

import { useCallback } from 'react';
// import { Button } from 'antd';
import BasePageWrap from '&/components/ResourceLib/BasePageWrap';
import StewardMsg from '../InteractiveMsg/StewardMsg';
import PostMessage from './PostMessage';
import './index.scss';

function StewardCenter() {
    const listRef = useRef();
    const onSended = useCallback(() => {
        listRef.current.refresh();
    }, []);

    return (
        <BasePageWrap type="card" title={intl.get('message.stewardCenter')}>
            <div className="steward-center">
                <PostMessage onSended={onSended} />
                <StewardMsg ref={listRef}></StewardMsg>
            </div>
        </BasePageWrap>
    );
}

export default StewardCenter;
